import { Bob } from "../stores/Bob";
import { makeSpreadsheetLine } from "./spreadSheet";
import { makeTransactionsListLine } from "./transactionsList";
import {
  makeTransactionsPage,
  TransactionViewOutput,
} from "./transactionViewer";
import { CurrencySnapshot } from "./types";

export interface OurOnchainOutboundTransaction {
  amount_satoshis: number;
  platform_fee_satoshis: number;
  total_deducted_satoshis: number;
  transaction_identifier: string | null;
  destination_address: string;
  uuid: string;
  created_at: number;
  currency_snapshot: CurrencySnapshot;
}

export const makeSpreadsheetLineForOnchainOutbound = (
  txData: OurOnchainOutboundTransaction,
  bob: Bob
) => {
  return makeSpreadsheetLine({
    type: "Onchain Send",
    status: txData.transaction_identifier ? "Broadcast" : "Pending",
    uuid: txData.uuid,
    createdAtInteger: txData.created_at,
    currencySnapshot: txData.currency_snapshot,
    currency: bob.currencyCode,
    amountSatoshis: txData.amount_satoshis,
    isCredit: false,
    comment: null,
    payRequest: null,
    routingFeeSatoshis: null,
    platformFeeSatoshis: txData.platform_fee_satoshis,
    lightningAddress: null,
    onchainTransactionId: txData.transaction_identifier,
    onchainReceivingAddress: txData.destination_address,
    onchainConfirmations: null,
  });
};

export const makeTransactionsListLineForOnchainOutbound = (
  txData: OurOnchainOutboundTransaction,
  bob: Bob
) => {
  const label = txData.transaction_identifier
    ? "Onchain Sent"
    : "Onchain Sending";

  return makeTransactionsListLine({
    amountSatoshis: txData.amount_satoshis,
    label: label,
    isConfirmed: !!txData.transaction_identifier,
    createdAtInteger: txData.created_at,
    comment: null,
    currencySnapshot: txData.currency_snapshot,
    currency: bob.currencyCode,
    isCredit: false,
    modelName: "OnchainOutboundTransaction",
    uuid: txData.uuid,
    lightningAddress: null,
    zapName: null,
    zapPictureUrl: null,
    onchainTransactionId: txData.transaction_identifier,
    onchainReceivingAddress: txData.destination_address,
    onchainConfirmations: null,
  });
};

export type OnchainOutboundTransactionViewOutput = TransactionViewOutput & {
  transactionId: string | null;
  destinationAddress: string;
  platformFeeSatoshis: number;
  totalDeductedSatoshis: number;
  mempoolTxUrl: string | null;
  mempoolAddressUrl: string;
};

export const makeTransactionPageDataForOnchainOutbound = (
  txData: OurOnchainOutboundTransaction,
  bob: Bob
): OnchainOutboundTransactionViewOutput => {
  const baseData = makeTransactionsPage({
    header: txData.transaction_identifier ? "Onchain Sent" : "Onchain Sending",
    uuid: txData.uuid,
    createdAtInteger: txData.created_at,
    currencySnapshot: txData.currency_snapshot,
    currency: bob.currencyCode,
    amountSatoshis: txData.amount_satoshis,
    isCredit: false,
    comment: null,
    payRequest: null,
    routingFeeSatoshis: null,
    platformFeeSatoshis: txData.platform_fee_satoshis,
    lightningAddress: null,
  });

  return {
    ...baseData,
    transactionId: txData.transaction_identifier,
    destinationAddress: txData.destination_address,
    platformFeeSatoshis: txData.platform_fee_satoshis,
    totalDeductedSatoshis: txData.total_deducted_satoshis,
    mempoolTxUrl: txData.transaction_identifier
      ? `https://mempool.space/tx/${txData.transaction_identifier}`
      : null,
    mempoolAddressUrl: `https://mempool.space/address/${txData.destination_address}`,
  };
};
